export default __webpack_public_path__ + "static/media/Oswald-Light.8716983b.ttf";